/**
 * ExtraFieldConditionType - Condition qui vérifie une valeur d'extraField
 * Identique à Flutter ExtraFieldConditionType (si existe) ou condition personnalisée
 */

import {ConditionType} from '../types/ConditionType';
import {GameState} from '../../../models/GameState';
import GameStateHelper from '../../../helpers/GameStateHelper';

export class ExtraFieldConditionType implements ConditionType {
  typeName = 'COND_EXTRA_FIELD';
  messageKey = 'laventurier.condition.extra_field.name';
  descriptionKey = 'laventurier.condition.extra_field.desc';
  errorKey = 'laventurier.condition.extra_field.error';
  hasValue = true;
  hasAttribute = true;

  evaluate(gameState: GameState, condition: any): boolean {
    const fieldType = condition.attribute || condition.attributeId || condition.typeName;
    const expectedValue = condition.value;

    if (!fieldType) {
      console.log('[ExtraFieldConditionType] FALSE: no field type specified');
      return false;
    }

    const field = GameStateHelper.getAdventureExtraField(gameState, fieldType);
    if (!field) {
      console.log(`[ExtraFieldConditionType] FALSE: extraField ${fieldType} not found`);
      return false;
    }

    const currentValue = field.currentValue || field.value || 0;
    const expected = Number(expectedValue) || 0;

    // Comparaison simple (peut être étendue pour >, <, etc.)
    const result = Number(currentValue) === expected;
    console.log(
      `[ExtraFieldConditionType] ${result ? 'TRUE' : 'FALSE'}: ${fieldType} = ${currentValue} (expected: ${expected})`,
    );
    return result;
  }
}
